var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog304(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_304"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_304",
    "data-name": 304,
    className: "cls-2",
    d: "M9.65,10.72C-2.13,28.8,16.47,57.85,28.71,71.06A90.31,90.31,0,0,0,64.13,94.47c5.7,2.07,27,8.19,29.52-1.32.82-3.08-5.71-7.21-7.88-8.68C54.54,63.37,53.19,5.23,29,1.73,21.49.64,13.34,5.05,9.65,10.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog304);
export default __webpack_public_path__ + "static/media/dog_304.3a907e33f0bd49a7653b88ea62e477ab.svg";
export { ForwardRef as ReactComponent };